import { beHttp } from '../beHttp';
import type { SessionLite } from '../../../types/session-lite';

export interface SessionsByDayResponse {
  [dateISO: string]: SessionLite[];
}

export interface SessionsByDayQuery {
  from?: string;
  to?: string;
  status?: string;
}

/**
 * Obtiene las sesiones agrupadas por día.
 *
 * Va a psiplatform-be (mysql-read directo), NO a api-core: mismo dato que ya
 * sirve `/api/psychologist/sessions` (usado por la vista semanal), evitando la
 * divergencia de `status` que traía el endpoint legado de api-core (una
 * sesión activa podía volver marcada `settled`, ocultando las acciones del
 * modal de detalle en Mensual/Diaria — ver SessionDetailsModal `isSettled`).
 */
export async function getSessionsByDay(params?: SessionsByDayQuery): Promise<SessionsByDayResponse> {
  // Añadir un parámetro de timestamp para evitar respuestas 304 Not Modified
  const timestamp = Date.now();

  try {
    const response = await beHttp.get<SessionsByDayResponse>(
      '/api/psychologist/sessions/by-day',
      {
        ...params,
        _t: timestamp
      }
    );

    return response;
  } catch (error) {
    console.error('Error obteniendo sesiones por día:', error);
    return {}; // Devolver objeto vacío en caso de error
  }
}
